import type { PaintFinish } from '../../types';

/** MeshPhysicalMaterial에 그대로 넘기는 마감 파라미터. */
export interface PaintFinishMaterial {
  metalness: number;
  roughness: number;
  clearcoat: number;
  clearcoatRoughness: number;
}

const PAINT_FINISH_MATERIAL_PRESETS: Record<PaintFinish, PaintFinishMaterial> = {
  metallic: { metalness: 0.75, roughness: 0.32, clearcoat: 1, clearcoatRoughness: 0.08 },
  pearl: { metalness: 0.4, roughness: 0.22, clearcoat: 1, clearcoatRoughness: 0.05 },
  matte: { metalness: 0.2, roughness: 0.78, clearcoat: 0, clearcoatRoughness: 0.5 },
};

function isPaintFinish(finish: string): finish is PaintFinish {
  return Object.prototype.hasOwnProperty.call(PAINT_FINISH_MATERIAL_PRESETS, finish);
}

/**
 * 모르는 마감은 메탈릭으로 되돌립니다.
 *
 * 인자를 PaintFinish가 아니라 string으로 받는 이유는, 카탈로그를 손보다가 오타가
 * 났을 때 차가 아예 안 보이는 것보다 기본 마감으로라도 칠해지는 편이 낫기 때문입니다.
 * 카탈로그 자체의 오타는 PaintOption 타입이 컴파일 시점에 잡습니다.
 */
export function resolvePaintFinishMaterial(finish: string): PaintFinishMaterial {
  if (!isPaintFinish(finish)) {
    return PAINT_FINISH_MATERIAL_PRESETS.metallic;
  }
  return PAINT_FINISH_MATERIAL_PRESETS[finish];
}
